import { isCompanyUser } from "@/utils/roleStorage";
import SVGWrapper from "@components/SVGWrapper";
import React from "react";

const SidebarButton = ({
  label,
  icon,
  active,
  onClick,
  role,
  expand = true,
}) => {
  const buttonStyle = {
    width: !expand ? "fit-content" : "100%",
    padding: 10,
    borderRadius: 10,
    justifyContent: "flex-start",
    alignItems: "center",
    gap: expand ? 8 : 0,
    display: "inline-flex",
    cursor: "pointer",
    color: active ? "white" : "#111111",
  };
  return (
    <div
      style={buttonStyle}
      onClick={onClick}
      className={
        active
          ? isCompanyUser()
            ? "bg-tale-business"
            : "bg-tale-normal"
          : ""
      }
    >
      <div style={{ width: 24, height: 24, position: "relative" }}>
        <SVGWrapper
          src={process.env.PUBLIC_URL + icon}
          color={active ? "white" : "black"}
        />
      </div>
      <div
        style={{
          fontSize: 14,
          fontFamily: "revert",
          fontWeight: "600",
          maxWidth: expand ? 300 : 0,
        }}
        className={`transition-all overflow-hidden text-nowrap ${
          expand ? "visible opacity-100" : "invisible opacity-0"
        }`}
      >
        {label}
      </div>
    </div>
  );
};

export default SidebarButton; // Make sure to export the component properly
